import { TAB_HIDE, TAB_SHOW } from '../../../../../../common/tabs/tabs.constants';
import { template } from 'lodash';
import { GridController, gridTpl } from '../../../../../../common/grid/grid.controller';
import { IDS } from '../../pnp-doc.constants';
import { getAccreditationDocument } from '../../pnp-doc.actions';

class pnpDocumentAccreditationGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$ngRedux = $ngRedux; // Store $ngRedux in this
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocumentAccreditationGrid;
        // Enable the custom button accreditation
        this.showCustomButton = true;
        this.customButtonName = 'Add Doc Accrediation';
        this.filterTemplate = './pnp-document-accreditation-grid-filter.html';

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Document Accreditation Schemes ', mapper: 'documentAccreditationSchemes' },
            { title: 'Document Accreditation Section', mapper: 'documentAccreditationSection' },
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getAccreditationDocument }
        )(this);

        this.filter.identifier = this.identifier;
        this.dataAction = this.getAccreditationDocument;
        this.exportService = this.getAccreditationDocument;

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

pnpDocumentAccreditationGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpDocumentAccreditationGrid = {
    bindings: {
        onRemove: '&',
        onReset: '&',
    },
    controller: pnpDocumentAccreditationGridController,
    ...gridTpl
};
